import { Logger } from '@sitecore-search/common';
import { getServiceConfig } from '../config.js';
import { cleanJSONSchema } from '../events/eventUtils.js';
import Cache from './cache.js';
import { getAPIHeaders } from './headers.js';
const CACHE = new Cache('api-adapter');
const DEFAULT_FETCH_OPTIONS = {
    cache: true,
};
export default class RFKApiAdapter {
    static async trackEvent(params) {
        const formattedParams = cleanJSONSchema(params);
        const { eventUrl, apiKey } = getServiceConfig();
        try {
            const response = await fetch(eventUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': apiKey,
                },
                body: JSON.stringify(formattedParams),
            });
            return response.json();
        }
        catch (e) {
            Logger.error(e);
            Logger.error('There was a problem on the service call');
            return e.message || null;
        }
    }
    static async callApiWithoutCache(url, fetchOptions) {
        try {
            const response = await fetch(url, fetchOptions);
            const content = await response.json();
            return Promise.resolve(content);
        }
        catch (e) {
            Logger.error(e);
            Logger.error('There was a problem on the service call');
            return e.message || null;
        }
    }
    static async callApiWithCache(url, fetchOptions) {
        const cacheKey = CACHE.createKey(fetchOptions);
        if (CACHE.has(cacheKey)) {
            return CACHE.get(cacheKey);
        }
        const response = await RFKApiAdapter.callApiWithoutCache(url, fetchOptions);
        CACHE.set(cacheKey, response);
        return response;
    }
    static async callApi(params, options = DEFAULT_FETCH_OPTIONS) {
        const { searchUrl } = getServiceConfig();
        const fetchOptions = {
            method: 'POST',
            headers: await getAPIHeaders(),
            body: JSON.stringify(params),
            signal: options.signal,
        };
        if (options.cache) {
            return RFKApiAdapter.callApiWithCache(searchUrl, fetchOptions);
        }
        return RFKApiAdapter.callApiWithoutCache(searchUrl, fetchOptions);
    }
    static clearCache() {
        CACHE.clear();
    }
}
